import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCk7Tx97y9HEr3kQEBW79Qgymw3MS0S96Q",
  // Serve the OAuth handler from the app's OWN origin (babyresell.shop) via the
  // /__/auth proxy in vercel.json. Using the exact same origin — not just the
  // same registrable domain — is what stops iOS Safari/ITP from treating the
  // auth host as a tracking "bounce" and purging its storage (which caused the
  // redirect sign-in to hang forever). Override with the env var if needed.
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "babyresell.shop",
  projectId: "babyresell",
  storageBucket: "babyresell.firebasestorage.app",
  messagingSenderId: "34682053025",
  appId: "1:34682053025:web:a3ae94b28c34129924ebe0",
  measurementId: "G-SB6DTRBLB1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize providers
export const googleProvider = new GoogleAuthProvider();
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Web OAuth client ID for Google Identity Services (GIS). This is the same
// "Web SDK" client Firebase uses for Google sign-in. GIS lets us obtain a
// Google ID token directly on our own page (no redirect/popup handler), which
// is the only reliable Google sign-in path on iOS Safari (ITP blocks the
// Firebase redirect handler). Override via env if the client ever changes.
export const GOOGLE_WEB_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID ||
  '34682053025-u604u8fpjgv30t9tb435s1s5v0rm4u1o.apps.googleusercontent.com';

export default app;
